import React from 'react';
import { CheckCircle, AlertCircle, XCircle } from 'lucide-react';

const COVERAGE_CONFIG = {
  STRONG: {
    label: 'Strong',
    icon: CheckCircle,
    color: 'var(--zt-strong)',
    className: 'coverage-badge--strong'
  },
  PARTIAL: {
    label: 'Partial',
    icon: AlertCircle,
    color: 'var(--zt-partial)',
    className: 'coverage-badge--partial'
  },
  GAP: {
    label: 'Gap',
    icon: XCircle,
    color: 'var(--zt-gap)',
    className: 'coverage-badge--gap'
  }
};

const VendorCoverageBadge = ({ coverage, showLabel = false, size = 'sm' }) => {
  if (!coverage) return null;

  const config = COVERAGE_CONFIG[coverage];
  if (!config) return null;

  const Icon = config.icon;
  const iconSize = size === 'sm' ? 12 : size === 'md' ? 14 : 16;

  return (
    <span
      className={`coverage-badge coverage-badge--${size} ${config.className}`}
      title={config.label}
    >
      <Icon size={iconSize} color={config.color} />
      {showLabel && <span className="coverage-badge-label">{config.label}</span>}
    </span>
  );
};

export default VendorCoverageBadge;
